export default {
  elevation1: {
    boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.1) !important",
  },
};
